<div class="grid mb-2">
	<!-- NO SITE SELECTED ALERT -->
	<div *ngIf="currentSite === undefined" class="col-12 py-0">
		<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<i class="pi cm-alert text-lg text-yellow-700"></i>
			<p-tag [value]="('NO_SITE_DEVICE_ALERT' | translate)" severity="warning" styleClass="text-lg"></p-tag>
		</div>
	</div>
	<!-- SHARED SITE ALERT -->
	<div *ngIf="currentSite !== undefined && !currentSite.CurrentlyOwned" class="col-12 pt-0">
		<div class="flex align-items-center justify-content-center bg-purple-100 p-1 border-round-xl">
			<i class="pi cm-share text-lg text-purple-700"></i>
			<p-tag [value]="'SHARED_SITE' | translate" styleClass="p-tag-purple"></p-tag>
		</div>
	</div>
	<div class="col-12 pb-0">
		<div class="flex align-items-center justify-content-center text-lg text-0 font-medium">{{ 'MAXIMUM_SHARING_SYSTEM'
			| translate }}</div>
	</div>
</div>
<div class="border-1 border-0 border-round p-3">
	<!-- FILTER -->
	<app-devices-vct-list-edit-filters [deviceFilters]="deviceFilters" [errorCount]="errorCount">
	</app-devices-vct-list-edit-filters>
	<!-- VCT LIST EDIT -->
	<div class="card px-0 border-round">
		<div *ngIf="loadingInvitations || loadingList || loadingMassiveSharing">
			<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
				<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
			</div>
		</div>
		<p-treeTable *ngIf="!loadingInvitations && !loadingList && !loadingMassiveSharing" [value]="devices"
			[totalRecords]="devices.length" (onNodeExpand)="onDeviceExpand($event)"
			(onNodeCollapse)="onDeviceCollapse($event)" [scrollable]="true" scrollHeight="900px" [virtualScroll]="true"
			[virtualScrollItemSize]="46">
			<!-- [scrollable]="virtualEnableScroll"
			[scrollHeight]="virtualEnableScroll ? '900px' : null"
			[virtualScroll]="virtualEnableScroll"
			[virtualScrollItemSize]="70"> -->
			<ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
				<tr [ttRow]="rowNode" class="cursor-pointer" [class]="onExtendedMobile() ? 'flex flex-row' : ''"
					[class]="(rowNode.level === 0) ? 'surface-400 hover:bg-blue-200 border-top-1 border-bluegray-900' : ''">
					<!-- <td [class]="onExtendedMobile() ? 'flex w-full' : ''"> -->
					<!-- NAME -->
					<td [class]="onExtendedMobile() ? 'w-4rem' : this.screenWidth <= LG_WIDTH ? 'w-4rem' : 'w-4rem'">
						<div class="flex align-items-center justify-content-start text-left">
							<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
							<i class="pi {{rowNode.node.icon}} text-4xl text-primary mr-3"></i>
							<div class="text-xl font-medium" style="white-space: pre-wrap">{{ rowData.AliasName!==undefined &&
								rowData.AliasName!==''? getSplitString(rowData.AliasName):getSplitString(rowData.Name) |
								truncate:[30]}}</div>
						</div>
					</td>
					<!-- KEYCODE / SIP ACCOUNT -->
					<td *ngIf="this.screenWidth > LG_WIDTH" class="w-4rem">
						<div class="flex align-items-center justify-content-center text-center">
							<div>{{ getRowInfo(rowData) }}</div>
						</div>
					</td>
					<!-- MAIL INPUTTEXT -->
					<td [class]="onExtendedMobile() ? 'w-4rem' : this.screenWidth <= LG_WIDTH ? 'w-5rem' : 'w-5rem'">
						<!-- <div class="flex flex-column"> -->
							<input *ngIf="isModifyMail(rowData) && !isFeatureApp(rowData)" type="text" pInputText
								[ngClass]="dynamicInputTextWidth()" [(ngModel)]="rowData.OwnerEmail"
								placeholder="{{'NOT_ASSIGNED' | translate}}" (input)="changeMailModule(rowData)" />
							<input *ngIf="isModifyMail(rowData) && isFeatureApp(rowData)" type="text" pInputText
								[ngClass]="dynamicInputTextWidth()" [(ngModel)]="rowData.SipAccount.UserEmail"
								placeholder="{{'NOT_ASSIGNED' | translate}}" (input)="changeMailApp(rowData)" />
						<!-- </div> -->
					</td>
					<!-- BUTTON ACTIONS -->
					<td [class]="onExtendedMobile() ? 'w-2rem' : this.screenWidth <= LG_WIDTH ? 'w-2rem' : 'w-2rem'">
						<i *ngIf="rowData.WarningError" pTooltip="{{ rowData.WarningErrorType | translate}}"
							tooltipPosition="bottom" class="pi cm-alert text-2xl"></i>
						<p-button *ngIf="isModifyMail(rowData)" pTooltip="{{ 'ASSING_TO_ME' | translate}}"
							tooltipPosition="bottom" icon="pi cm-user" size="large" (click)="assignToMe(rowData)"
							[rounded]="false" [text]="true" severity="primary">
						</p-button>
						<p-button *ngIf="isModifyMail(rowData)" pTooltip="{{ 'REVOKE_INVITATION' | translate}}"
							tooltipPosition="bottom" icon="pi cm-cancel" size="large" (click)="removeEmail(rowData)"
							[rounded]="false" [text]="true" severity="danger">
						</p-button>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage" let-columns>
				<tr>
					<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
				</tr>
			</ng-template>
		</p-treeTable>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>